import { DataTable } from "@/components/datatable/datatable"
import { DataTableSupabase } from "@/components/datatable/supadatatable"
import { Page, PageTitle } from "@/components/page"
import { usePage } from "@/components/page/hooks"
import { Button } from "@/components/ui/button"
import { supabase } from "@/lib/data"
import { FileText, Plus, Trash2, Sparkles, Pencil } from "lucide-react"
import { useCallback, useEffect, useState } from "react"
import { useAssistant } from "@/components/assistant/AssistantProvider"
import { FORMS_CHANGED_EVENT } from "@/lib/assistant/modules/forms"

export const forms = {
  title: "Forms",
  description: "Manage your organization's Forms.",
  route: "/evaluations/forms",
  url: "/evaluations/forms",
  icon: FileText,
  component,
  group: "evaluations",
  resource: "forms",
  action: "read",
} satisfies PageConfig

const columns: Columns<Form> = {
  title: { header: "Title", size: 600 },
  created_at: { header: "Created", cell: DataTable.cellRender.date, size: 166 },
}

function component() {

  const { navigate, team } = usePage()
  const assistant = useAssistant()
  const [tableKey, setTableKey] = useState(0)

  const menu: DropdownMenuContents = [{
    title: "Edit", action: async (v) => {
      navigate(`/evaluations/forms/${v.id}`)
    },
    icon: <Pencil />,
  }, {
    title: "Delete", action: async (v) => {
      await supabase.from("forms").delete().eq("id", v.id)
    },
    icon: <Trash2 />,
    ask: "Are you sure you want to delete this form?",
  }]

  const filter = useCallback(q => q.eq("team", team?.id), [team])
  // The assistant changes forms from any page; refresh the list when it does
  useEffect(() => {
    const refresh = () => setTableKey(k => k + 1)
    window.addEventListener(FORMS_CHANGED_EVENT, refresh)
    return () => window.removeEventListener(FORMS_CHANGED_EVENT, refresh)
  }, [])

  return <Page>
    <div className="h-full grid grid-rows-[auto_1fr] gap-4">
      <div className="flex">
        <PageTitle />
        <div className="grow"></div>
        <div className="flex gap-2">
          {assistant.enabled && (
            <Button variant="outline" className="rounded-lg" onClick={() => assistant.openWith("Help me build a new Magic Form: ")}>
              <Sparkles className="h-4 w-4" />Build with AI
            </Button>
          )}
          <Button className="rounded-lg" onClick={() => navigate('/evaluations/forms/new')}><Plus className="h-4 w-4" />New Form</Button>
        </div>
      </div>
      <DataTableSupabase
        key={tableKey}
        table="forms"
        columns={columns}
        showSelection
        onRowClick={"/evaluations/forms"}
        sort={["created_at", "desc"]}
        actions={menu.length > 0 ? menu : undefined}
        filter={filter}
        enableServerSideFiltering={true}
        searchableColumns={["title"]}
      />
    </div>
  </Page>

}
